import { Pipe, PipeTransform } from '@angular/core';
import { Money } from '@generated/types';

@Pipe({ name: 'priceCommission' })
export class PriceCommissionPipe implements PipeTransform {
  transform({ amount, cost }: { amount: Money; cost: Money }): Money {
    const commission = amount.amount - cost.amount;
    return {
      amount: commission,
      currency: amount.currency,
    };
  }
}
